<form [formGroup]="leaseDetailService.entityAcquisition" (ngSubmit)="onFormFieldChange()">
  <div class="grid">
    <div class="col-12">
      <div class="main-title">
        Documentos
      </div>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
      <div class="field field-flex">
        <label for="paymentDate">Fecha de pago:*</label>
        <input 
          type="date" 
          pInputText 
          id="paymentDate" 
          formControlName="paymentDate" 
          required 
          (change)="onFormFieldChange()" />
        <ng-container *ngIf="e.get('paymentDate')?.invalid && (e.get('paymentDate')?.dirty || e.get('paymentDate')?.touched)">
          <small class="p-error" *ngIf="e.get('paymentDate')?.errors?.['required']">La fecha de pago es obligatoria.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
      <div class="field field-flex">
        <label for="providerId">Proveedor:</label>
        <div class="flex justify-content-center flex-column">
          <p-dropdown 
            formControlName="providerId" 
            [panelStyle]="{'width': '100%' }" 
            [style]="{'height': '45px'}" 
            scrollHeight="150px" 
            [options]="leaseDetailService.providers" 
            optionLabel="label" 
            optionValue="value" 
            [filter]="true" 
            filterBy="label" 
            [showClear]="true" 
            placeholder="Selecciona un proveedor"
            (onChange)="onFormFieldChange()">
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center" *ngIf="e.value.providerId">
                <div>{{leaseDetailService.getProviderName(e.value.providerId)}}</div>
              </div>
            </ng-template>
            <ng-template let-provider pTemplate="item">
              <div class="flex align-items-center">
                <div>{{ provider.label }}</div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
      <app-input-single-file 
        label="Comprobante de pago"
        (fileUrl)="onFileSelected($event, 'paymentProof')"
        (fileDeleted)="onFileDeleted('paymentProof')"
        (downloadRequested)="onDownloadRequested($event, 'comprobante_pago_adquisicion')"
        [tooltip]="'Comprobante de pago de la adquisición del activo'"
        [documentName]="'paymentProof'"
        [folder]="'assetAcquisition'"
        [id]="leaseDetailService.id"
        [fileUrlValue]="data?.assetAcquisition?.paymentProof">
      </app-input-single-file>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
      <app-input-single-file 
        label="Factura en formato pdf"
        (fileUrl)="onFileSelected($event, 'invoicePdf')"
        (fileDeleted)="onFileDeleted('invoicePdf')"
        (downloadRequested)="onDownloadRequested($event, 'factura_pdf')"
        [tooltip]="'Factura del activo en formato PDF'"
        [documentName]="'invoicePdf'"
        [folder]="'assetAcquisition'"
        [id]="leaseDetailService.id"
        [fileUrlValue]="data?.assetAcquisition?.invoicePdf">
      </app-input-single-file>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
      <app-input-single-file 
        label="Factura en formato xml"
        (fileUrl)="onFileSelected($event, 'invoiceXml')"
        (fileDeleted)="onFileDeleted('invoiceXml')"
        (downloadRequested)="onDownloadRequested($event, 'factura_xml')"
        [tooltip]="'Factura del activo en formato XML'"
        [documentName]="'invoiceXml'"
        [folder]="'assetAcquisition'"
        [id]="leaseDetailService.id"
        [fileUrlValue]="data?.assetAcquisition?.invoiceXml">
      </app-input-single-file>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
      <app-input-single-file 
        label="Foto de la tarjeta de circulación"
        (fileUrl)="onFileSelected($event, 'circulationCard')"
        (fileDeleted)="onFileDeleted('circulationCard')"
        (downloadRequested)="onDownloadRequested($event, 'tarjeta_circulacion')"
        [tooltip]="'Fotografía de la tarjeta de circulación del vehículo'"
        [documentName]="'circulationCard'"
        [folder]="'assetAcquisition'"
        [id]="leaseDetailService.id"
        [fileUrlValue]="data?.assetAcquisition?.circulationCard">
      </app-input-single-file>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
      <app-input-single-file 
        label="Pago de impuestos"
        (fileUrl)="onFileSelected($event, 'taxPayment')"
        (fileDeleted)="onFileDeleted('taxPayment')"
        (downloadRequested)="onDownloadRequested($event, 'pago_impuestos')"
        [tooltip]="'Comprobante de pago de impuestos del activo'"
        [documentName]="'taxPayment'"
        [folder]="'assetAcquisition'"
        [id]="leaseDetailService.id"
        [fileUrlValue]="data?.assetAcquisition?.taxPayment">
      </app-input-single-file>
    </div>
    <div class="col-12 text-right">
      <button pButton pRipple label="Guardar" icon="fa-solid fa-check" class="p-button-success" type="submit"></button>
    </div>
  </div>
</form>

<!-- Toast para notificaciones -->
<p-toast position="top-right"></p-toast>
